import React, { useMemo } from 'react';
import PassInfo from '../../../common_lib_front/types/passInfo';
import { PassInfoData } from '../../../utils/useVehicleConfigs';
import EditVehiclePassForm from './editVehiclePassForm';
import style from './getPasses.module.css';
import { VehiclePass } from './types';
import { PassOptionErrorsType } from './validateVehicleData';

interface AddVehicleInfoProps {
  passInfos: PassInfoData[];
  // passes: Array<
  //   {
  //     passId: string;
  //     status: string;
  //     paid: string;
  //     endDate: string;
  //     passInfoId: string;
  //   } & {
  //     vehicle?: VehiclePass;
  //     passInfo: { priceInfo?: { chargeForFullCapacity: boolean } };
  //   }
  // >;
  passes: PassInfo[];
  days: number;
  startDate: string;
  endDate: string;
  isGuestLink: boolean | undefined;
  priceSums?: Record<string, number> | null;
  errors?: PassOptionErrorsType;
  addVehiclePass: (
    passInfoId: string,
    passName: string,
    capacityOverride: number | null,
  ) => void;
  removeVehiclePass: (passInfoId: string) => void;
  handleVehicleChange: (
    passIndex: number,
    field: keyof VehiclePass,
    value: string,
  ) => void;
  handleCheckboxChange: (passIndex: number, val?: boolean) => void;
}

const AddVehicleInfo: React.FC<AddVehicleInfoProps> = ({
  passInfos,
  passes,
  days,
  startDate,
  endDate,
  isGuestLink,
  priceSums,
  errors,
  addVehiclePass,
  removeVehiclePass,
  handleVehicleChange,
  handleCheckboxChange,
}) => {
  console.log('[passes]', passes);
  const getDefaultDates = (passInfoData: PassInfoData) => {
    const currentDate = new Date().toISOString().split('T')[0];
    let maxEndDate;
    if (startDate) {
      maxEndDate = new Date(startDate);
    } else {
      maxEndDate = new Date();
    }
    maxEndDate.setDate(
      maxEndDate.getDate() + (passInfoData?.durationInfo?.duration1 || 0),
    );
    const maxEndDateString = maxEndDate.toISOString().split('T')[0];
    const defaultStartDate = startDate || currentDate;
    const defaultEndDate =
      endDate && new Date(endDate) <= maxEndDate ? endDate : maxEndDateString;
    return { defaultStartDate, defaultEndDate, maxEndDateString };
  };

  const passesByType = useMemo(() => {
    const res: { [passInfoId: string]: (PassInfo & { passIndex: number })[] } = {};
    passes.forEach((p, passIndex) => {
      const passInfo = passInfos.find(pi => pi.passInfoId === p.passInfoId);
      if (!res[p.passInfoId]) {
        res[p.passInfoId] = [];
      }
      res[p.passInfoId].push({
        ...p,
        passIndex,
        passInfo: passInfo || null,
      });
    });
    return res;
  }, [passes]);

  return (
    <>
      {passInfos.map(passInfo => {
        const passInfoId = passInfo.passInfoId;
        const { maxEndDateString } = getDefaultDates(passInfo);
        // if (!paidPassIds.includes(passInfoId)) return null;
        return (
          <div key={passInfoId} className={`${style.mainInnerBox}`}>
            {passesByType[passInfoId]?.map(pass => (
              <>
                <div
                  className={`${style.innerBox}  ${
                    pass.status.includes('incomplete') && style.incompleted
                  }`}
                  key={pass.passInd}
                >
                  <div className={style.passOptions}>
                    <div className={`${style.passHeader} ${style.customPassHeader}`}>
                      <div>
                        <h2>{passInfo.name}</h2>
                        <div className={style.row}>
                          <div>
                            <p style={{ margin: '10px 0px 0px 0px' }}>
                              {passInfo.description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className={style.statusLabel}>
                        {pass.status.includes('incomplete')
                          ? 'Incomplete'
                          : 'Complete'}
                      </div>
                    </div>
                    <EditVehiclePassForm
                      key={pass.passIndex}
                      passIndex={pass.passIndex}
                      vehiclePass={pass}
                      passInfoId={passInfoId}
                      errors={errors}
                      handleChange={(index, field, value) =>
                        handleVehicleChange(index, field, value)
                      }
                      handleCheckboxChange={index =>
                        handleCheckboxChange(index)
                      }
                      smsAlert={false}
                      duration={passInfo.durationInfo?.duration1}
                      disabled={['inactive', 'active'].includes(pass.status)}
                      initialStartDate={startDate}
                      initialEndDate={endDate}
                      maxEndDate={maxEndDateString}
                      promotionalAlert={false}
                      setSmsAlert={function (): void {
                        throw new Error('Function not implemented.');
                      }}
                      setPromotionalAlert={function (): void {
                        throw new Error('Function not implemented.');
                      }}
                    />
                  </div>
                </div>
              </>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default AddVehicleInfo;
